import { apolloClient } from '~/common/apollo'
import { action, computed, observable, store } from '~/common/mobx.decorator'
import { masterStore } from '~/stores'
import { GET_RECRUITERS } from '~/common/apollo/queries/recruiter.query'

@store()
class CareReferralTravellerStore {
	@observable recruiters = []

	@computed
	get referredRelationshipsOptions() {
		return masterStore.referredRelationships
	}

	@computed
	get recruiterOptions() {
		return this.recruiters?.map((item) => {
			return {
				label: item?.name,
				value: item?.id,
			}
		})
	}

	@action
	fetchRecruiters = async () => {
		const { data } = await apolloClient.query({
			query: GET_RECRUITERS,
		})
		this.recruiters = data.recruiters
	}
}

export const careReferralTravelStore = new CareReferralTravellerStore()
